import React, { useCallback, useState } from "react";
import { Card, TableContainer, Typography, Link } from "@mui/material";
import ClientModal from "./product_list";
import CustomDatagrid from "../../../components/datagrid";
import moment from "moment";
import subscriptionApi from "../../../services/subscription";
import { showLoader, hideLoader } from "../../../redux/loader/actions";
import { useDispatch } from "react-redux";

function ClientList({
  userData,
  rowCount,
  paginationModel,
  setPaginationModel,
  clientId,
  setClientId,
}) {
  const dispatch = useDispatch();
  const [selectedClient, setSelectedClient] = useState(null);
  const [subscriptionData, setSubscriptionData] = useState([]);
  const [rowCountSub, setRowCountSub] = useState(0);
  const [paginationModelSub, setPaginationModelSub] = useState({
    page: 0,
    pageSize: 10,
  });

  const openModal = (client) => {
    setSelectedClient(client);
    getSubscriptionData(client?.uuid);
  };
  const closeModal = () => {
    setSelectedClient(null);
  };

  const getSubscriptionData = useCallback(
    (id) => {
      dispatch(showLoader());
      const onSuccess = (res) => {
        dispatch(hideLoader());
        if (res?.data?.status) {
          setSubscriptionData(res?.data?.data);
          setRowCountSub(res?.data?.data?.pagination?.totalItems);
        }
      };
      const onFailure = (err) => {
        dispatch(hideLoader());
        console.error(err?.response?.data?.msg);
      };
      subscriptionApi?.getAllSubscriptionById(id).then(onSuccess, onFailure);
    },
    [paginationModelSub.page, paginationModelSub.pageSize, dispatch]
  );

  const clientListRows = Array.isArray(userData.users)
    ? userData.users.map((data, index) => ({
        id: index + 1,
        sno_id: paginationModel.page * paginationModel.pageSize + index + 1,
        client_id: data?.user?.client_id,
        name: data?.user?.username,
        organisation: data?.user?.organization_name,
        email: data?.user?.email,
        joined_on: moment.utc(data?.user?.created_at).format("DD/MM/YYYY"),
        mobile_number: data?.user?.mobile_number,
        uuid: data?.user?.uuid,
      }))
    : [];

  const columns = [
    {
      field: "sno_id",
      headerName: "S.No",
      width: 100,
      headerAlign: "left",
      align: "center",
      disableColumnMenu: true,
      sortable: false,
      renderCell: (params) => {
        return <span>{params.value}</span>;
      },
    },
    ...(clientId
      ? [
          {
            field: "client_id",
            headerName: "Client ID",
            width: 150,
            headerAlign: "left",
            align: "center",
            sortable: false,
            disableColumnMenu: true,
            renderCell: (params) => (
              <Link
                component="button"
                variant="body2"
                onClick={() => openModal(params.row)}
              >
                {params.value}
              </Link>
            ),
          },
        ]
      : []),
    {
      field: "name",
      headerName: "Name",
      width: 150,
      headerAlign: "left",
      align: "center",
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return <span>{params.value}</span>;
      },
    },
    {
      field: "organisation",
      headerName: "Organization / Group",
      width: 150,
      headerAlign: "left",
      align: "center",
      sortable: false,
      renderCell: (params) => {
        return <span>{params.value}</span>;
      },
      disableColumnMenu: true,
    },
    {
      field: "email",
      headerName: "Email",
      width: 200,
      headerAlign: "left",
      align: "center",
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return <span>{params.value}</span>;
      },
    },
    {
      field: "mobile_number",
      headerName: "Mobile Number",
      width: 150,
      headerAlign: "left",
      align: "center",
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return <span>{params.value}</span>;
      },
    },
    {
      field: "joined_on",
      headerName: "Joined On",
      width: 150,
      headerAlign: "left",
      align: "center",
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return <span>{params.value}</span>;
      },
    },
  ];

  return (
    <>
      <Card elevation={2}>
        <TableContainer
          sx={{
            overflowX: "auto",
            maxWidth: "100%",
          }}
        >
          {clientListRows.length === 0 ? (
            <Typography variant="h6" align="center" sx={{ padding: 2 }}>
              No Data Found
            </Typography>
          ) : (
            <CustomDatagrid
              rows={clientListRows}
              columns={columns}
              getRowId={(row) => row.id}
              paginationModel={paginationModel}
              onPaginationModelChange={setPaginationModel}
              rowCount={rowCount}
              disableSelectionOnClick={true}
              checkboxSelection={false}
              pagination
              pageSizeOptions={[5, 10, 20]}
            />
          )}
        </TableContainer>
      </Card>
      {selectedClient && (
        <ClientModal
          client={selectedClient}
          onClose={closeModal}
          subscriptionData={subscriptionData}
          rowCountSub={rowCountSub}
          setRowCountSub={setRowCountSub}
          paginationModelSub={paginationModelSub}
          setPaginationModelSub={setPaginationModelSub}
        />
      )}
    </>
  );
}

export default ClientList;
